// extracted by mini-css-extract-plugin
export default {"projectIcon":"VtKpbPbinnDElNAC9MjV","type":"myPjzuiU9N78VG289W_n"};